export default __webpack_public_path__ + "static/media/chatGpt.a85fd17b.svg";